import { findIndex } from 'lodash';
import moment from 'moment';
import { EventTypes } from './events';
import { sportTypeIds } from './eventConstants';
import { LeagueTypeIds } from './types';

const _ = { findIndex };

export const SearchTypes = {
    FLEX_LEAGUES: 'flexLeagues',
    EVENTS: 'events',
    PLAYERS: 'players',
    CLUBS: 'clubs',
};

export const SearchFilters = {
    EVENT_TEAM_TYPES: 'eventTeamTypes',
    SHOW_TENNIS_CONTENT: 'showTennisContent',
    SHOW_PICKLEBALL_CONTENT: 'showPickleballContent',
};

export const SeoPlayerSearchTypes = {
    ADULT_WOMEN: 1,
    ADULT_MEN: 2,
    JUNIOR_GIRLS: 3,
    JUNIOR_BOYS: 4,
};

// eslint-disable-next-line import/prefer-default-export
export const mapSearchFiltersToMultiselectOptions = (filterInputs, filtersPropName, searchTypes, searchTypesPropName) => {
    const filterTypes = searchTypes && searchTypes[searchTypesPropName] ? searchTypes[searchTypesPropName] : [];
    return filterTypes && filterTypes.map(filterType => {
        return {
            value: filterType.value,
            label: filterType.label,
            checked: filterInputs[filtersPropName] && filterInputs[filtersPropName][filterType.value],
        };
    });
};

export const filterModalPosition = (el) => {
    const filterBtnElement = el;
    const buttonDOMTop = filterBtnElement.offsetTop;
    const buttonDOMLeft = filterBtnElement.offsetLeft;
    return {
        left: `${buttonDOMLeft}px`,
        top: `${buttonDOMTop + 40}px`,
    };
};

// constants
export const SearchLimitPerPage = 10;
export const SearchNoFilterLimit = 3;
export const eventSearchLimitPerPage = 40;

export const filterSearchEventTypes = (eventTypes) => {
    let filteredEventTypes = eventTypes;

    // Remove event types that aren't going to be shown in the event type filter on the search page
    filteredEventTypes = filteredEventTypes.filter(type => type.id !== EventTypes.NON_TENNIS && type.id !== EventTypes.VIRTUAL);

    const freePlayEventTypeIndex = _.findIndex(filteredEventTypes, { id: EventTypes.FREE_PLAY });
    if (freePlayEventTypeIndex !== -1) {
        filteredEventTypes[freePlayEventTypeIndex].label = 'Player Created Play';
        filteredEventTypes.push(filteredEventTypes.splice(freePlayEventTypeIndex, 1)[0]);
    }

    return filteredEventTypes;
};

export const doesFilterHaveValue = filter => {
    if (filter) {
        return Object.values(filter).includes(true);
    }
    return false;
};

// SEO Search Utils

const { TENNIS, PICKLEBALL } = sportTypeIds;
const { ADULT_TEAM_TENNIS, ADULT_TEAM_PICKLEBALL, JUNIOR_TEAM_TENNIS, JUNIOR_TEAM_PICKLEBALL } = LeagueTypeIds;

export const getSeoPlayerSearchParamsForType = (type, sportType, location, requestSize) => {
    const { ADULT_WOMEN, ADULT_MEN, JUNIOR_BOYS, JUNIOR_GIRLS } = SeoPlayerSearchTypes;
    const pickleballMaxRating = 10;

    const params = new URLSearchParams();

    params.append('top', requestSize);
    params.append('skip', 0);
    params.append('utrType', 'verified');
    params.append('utrTeamType', sportType === TENNIS ? 'singles' : 'doubles');
    params.append('searchOrigin', 'searchPage');

    if (sportType === TENNIS) {
        params.append('showTennisContent', true);
        params.append('showPickleballContent', false);
        params.append('utrReliability', 'rated');
    }

    if (sportType === PICKLEBALL) {
        params.append('showPickleballContent', true);
        params.append('showTennisContent', false);
        params.append('utrMax', pickleballMaxRating);
    }

    if (location) {
        if (location?.locationName?.country) {
            params.append('locationCountryName', location?.locationName?.country);
        }
        if (location?.locationName?.state) {
            params.append('locationStateName', location?.locationName?.state);
        }
    }

    if (location?.locationCoordinates) {
        params.append('pin', `${location?.locationCoordinates?.lat},${location.locationCoordinates?.long}`);
        params.append('distance', '15mi');
    }

    const genderParam = 'gender';
    const primaryTagParam = 'primaryTags';
    const adultParam = 'Adult';
    const juniorParam = 'Junior';
    const maleGenderParam = 'M';
    const femaleGenderParam = 'F';

        switch (type) {
        case ADULT_WOMEN:
            params.append(genderParam, femaleGenderParam);
            params.append('searchOrigin', 'searchPage');
            params.append(primaryTagParam, adultParam);
            break;
        case ADULT_MEN:
            params.append(genderParam, maleGenderParam);
            params.append(primaryTagParam, adultParam);
            break;
        case JUNIOR_GIRLS:
            params.append(genderParam, femaleGenderParam);
            params.append(primaryTagParam, juniorParam);
            break;
        case JUNIOR_BOYS:
            params.append(genderParam, maleGenderParam);
            params.append(primaryTagParam, juniorParam);
            break;
        default:
            break;
    }

    return params;
};

export const getSeoEventSearchParamsForType = (sportType, location) => {
    const { TENNIS, PICKLEBALL } = sportTypeIds;
    const resultLimit = 10;
    const startDate = moment().format('MM/DD/YYYY');

    const params = new URLSearchParams();
    params.append('top', resultLimit);
    params.append('skip', 0);
    params.append('utrType', 'verified');
    params.append('utrTeamType', 'singles');
    params.append('range', `eventSchedule.eventStartUtc>=${startDate}`);
    params.append('searchOrigin', 'searchPage');

    if (sportType === TENNIS) {
        params.append('showTennisContent', true);
        params.append('showPickleballContent', false);
    }

    if (sportType === PICKLEBALL) {
        params.append('showPickleballContent', true);
        params.append('showTennisContent', false);
    }

    if (location.locationName) {
        if (location?.locationName?.country) {
            params.append('locationCountryName', location?.locationName?.country);
        }
        if (location?.locationName?.state) {
            params.append('locationStateName', location?.locationName?.state);
        }
    }

    if (location?.locationCoordinates) {
        params.append('pin', `${location?.locationCoordinates.lat},${location?.locationCoordinates.long}`);
        params.append('distance', '125mi');
    }

    return params;
};

export const getSeoLeagueSessionRequestForType = (sportType, location) => {
    const { TENNIS, PICKLEBALL } = sportTypeIds;
    const resultLimit = 10;
    const searchRadius = 50;

    let requestBody = {
        pagination: { take: resultLimit },
        searchProperties: {
            distanceFilter: {
                distance: searchRadius,
                lat: location?.locationCoordinates.lat,
                long: location?.locationCoordinates.long,
            },
            genderTypeIds: [],
            orderByRule: 0, // Ascending
            sortby: 'startdate',
            sessionDateStatuses: ['upcoming', 'inprogress'],
        },
    };

    if (sportType === TENNIS) {
        requestBody = {
            ...requestBody,
            searchProperties: {
                ...requestBody.searchProperties,
                leagueTypeIds: [ADULT_TEAM_TENNIS, JUNIOR_TEAM_TENNIS],
                sportTypeIds: [TENNIS],
            },
        };
    }

    if (sportType === PICKLEBALL) {
        requestBody = {
             ...requestBody,
             searchProperties: {
                ...requestBody.searchProperties,
                leagueTypeIds: [ADULT_TEAM_PICKLEBALL, JUNIOR_TEAM_PICKLEBALL],
                sportTypeIds: [PICKLEBALL],
            },
        };
    }

    return requestBody;
};

export const getUpdatedAgeTagsForPlayerSearch = (ageTags) => {
    const under12TagId = 6;
    const under14TagId = 7;
    const under16TagId = 8;
    const tagsToExclude = [under12TagId, under14TagId, under16TagId];
    return ageTags.filter((tag) => !tagsToExclude.includes(tag.id));
};
